import React, { useEffect } from "react"
import { Link, useLocation } from "react-router-dom"
import SidebarContent from "./sidebar_content"

const SidebarDrawer = ({onClose}) => {
  const location = useLocation();

  const closeDrawer = () => {
    if (onClose) onClose()
  }

  useEffect(() => {
    closeDrawer()
  }, [location])

  return (
    <React.Fragment>
      <div className="drawer-header">
        <div className="d-flex align-items-center w-100">
          <Link
            to="#"
            onClick={closeDrawer}
            className="d-flex"
          >
            <img alt="close" src="/images/close.svg" height={14}/>
          </Link>
          <div className="d-flex align-items-center justify-content-center flex-grow-1">
            <img alt="logo" src="/images/logo_bg.svg" height={20} />
            <div className="font-weight-bold text-secondary font-size-16 me-1">
              Шунхлай
            </div>
          </div>
        </div>
      </div>
      <div className="sidebar-drawer">
        <div className="h-100">
          <SidebarContent />
        </div>
      </div>
    </React.Fragment>
  );
};

export default SidebarDrawer;
